import { LocalService } from './../storage/local.service';
import { Injectable } from '@angular/core';

import { ConfigService } from './../config/config.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class PausasService {
  headers = new HttpHeaders({
    'accept': 'application/json',
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService,
    private localSecureService: LocalService
  ) { }

  async listaPausas() {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/listpausas`;

    try {
      return await this.httpClient.get(url).toPromise();
    } catch (error: any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

  async pausar(data:any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/setpausa`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error: any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

}
